import { makeStyles } from '@mui/styles';

const useCustomerInformationStyles = makeStyles({
	infoContainer: {
		backgroundColor: 'white',
		padding: '24px 16px',
		borderRadius: '20px',
		marginTop: 40,
	},
	title: {
		color: 'rgba(0, 0, 0, 0.6)',
		fontFamily: 'Montserrat',
		fontSize: 14,
	},
	clientName: {
		display: 'block',
		fontFamily: 'Montserrat',
		fontSize: 16,
		fontWeight: 800,
		textAlign: 'center',
	},
	adminTitle: {
		color: '#003C82',
		display: 'block',
		fontFamily: 'Montserrat',
		fontSize: 14,
		fontWeight: 700,
		letterSpacing: 0,
		marginBottom: 8,
	},
	containerConfig: {
		borderTop: '1px solid #70707029',
		marginTop: 10,
		paddingTop: 10,
	},
});

export default useCustomerInformationStyles;
